import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./styles.module.css";

export const TodayInMarketsSparklinePlaceholder = () => {
  return (
    <>
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
      <Placeholder.Image
        className={styles.todayInMarketsSparklineCardsPlaceholder}
      />
    </>
  );
};
